import { useLang } from "@/lib/i18n";
import { PageHead } from "@/components/Ui";
import { LeadForm } from "@/components/Forms";

export default function Contact() {
  const { t } = useLang();
  return (
    <div className="bg-grid" data-testid="contact-page">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
        <PageHead eyebrow={t("contact.eyebrow")} title={t("contact.title")} sub={t("contact.sub")} testid="contact-head" />
        <p className="mt-6 text-center text-sm text-slate-500" data-testid="contact-email-row">
          <a href="mailto:contact@managone.com" className="font-semibold text-brand hover:text-brand-dark" data-testid="contact-email-link">
            contact@managone.com
          </a>
        </p>
        <div className="mt-10">
          <LeadForm endpoint="/contact" withMessageRequired testid="contact-form" />
        </div>
      </div>
    </div>
  );
}
